import GatewayResult from "model/gameplay/records/results/gateway-result";
import CelebrateWinComponent from "slotworks/components/celebrate-win/celebrate-win-component";
import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import Result from "slotworks/model/gameplay/records/results/result";
import WaysResult from "slotworks/model/gameplay/records/results/ways-result";
import isAfterGatewayMC from "utils/is-after-mc-gateway";
import Logger = require("js-logger");
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import { HoldAndSpinRecord } from "ags/integration/records/hold-and-spin-record";
import { HoldAndSpinScatterResult } from "ags/integration/model/results/hold-and-spin-scatter-result";
import { Services } from "slotworks/services/services";
import Contract from "slotworks/utils/contracts/contract";
import { LLWildBonusResult } from "integration/builders/result/ll-wild-bonus-result-builder";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";

export default class CGCelebrateWinComponent extends CelebrateWinComponent {
    public miscWin(result: Result, textId?: string) {

        const isBNGatewayTrigger = result.cashWon === 0;
        const isHoldAndSpinScatter = result instanceof HoldAndSpinScatterResult;
        const isWildBonus = result instanceof LLWildBonusResult;
        const celebrateGatewayTrigger = isBNGatewayTrigger && !isHoldAndSpinScatter && !isWildBonus;

        if (isWildBonus) {
            return Contract.empty();
        }

        this.cleanup();

        if (celebrateGatewayTrigger) {
            Logger.log("Custom Footer: #1");

            // Yeesh. I do this because the gateway result is masquerading as a SymbolWinResult.
            const symbolResult = result as SymbolWinResult;
            const gatewayResult = result as GatewayResult;

            Components.footer.showMiscWin("lbl.sca");
            return Contract.empty();
        }

        if ((result as any).id === "pick") {
            Logger.log("Custom Footer: #2 (pick)");
            return this.showBonusFooterResult(result.cashWon);
        }

        const record = gameState.getCurrentGame().getRootRecord();

        if (isAfterGatewayMC() || isHoldAndSpinScatter) {
            const gatewayResult = record.getResultsOfType(GatewayResult)[0];
            const bonusResult = record.getResultsOfType(LLWildBonusResult)[0];

            let cashWon = gatewayResult ? gatewayResult.cashWon : bonusResult.cashWon;

            if (!cashWon) {
                const lastPick = record.children.filter((child) => child.cashWon).pop();
                cashWon = lastPick.cashWon;
            }

            Logger.log("Custom Footer: #3 (gateway mc)");
            return this.showBonusFooterResult(cashWon);
        }

        const isRetriggerResult = result instanceof ScatterResult;
        if (isRetriggerResult) {
            const payout = Services.currency.format(result.cashWon);

            Logger.log("Custom Footer: #4 (scatter result)");
            return Components.footer.showCustomResult(result, "fot.way", { total_payout: payout });
        }

        const results = record.getResultsOfType(WaysResult);
        const totalSpinWin = results.reduce((total, waysResult) => total - waysResult.cashWon, record.cashWon);

        Logger.log("Custom Footer: #5 (default win)");
        return Components.footer.showGameWin(totalSpinWin);
    }

    protected showBonusFooterResult(winValue: number) {
        const text =  Services.translations.get("bonus_wins_credits", { credits: Services.currency.format(winValue) });
        return Contract.wrap(() => Components.footer.showCustomMessage(text));
    }
}
